module.exports = __webpack_public_path__ + "static/media/endosee-product-img.9fe8e86e.png";